(function () {
  const KEY = "ach_location_v1";

  function uniqSorted(arr){
    return [...new Set(arr)].filter(Boolean).sort((a,b)=>a.localeCompare(b,'es'));
  }

  function getAllDistricts(data){
    const z = data.zones || {};
    const all = []
      .concat(z.lima_99 || [])
      .concat(z.lima_hoy || [])
      .concat(z.lima_24_48 || [])
      .concat(z.provincia || []);
    return uniqSorted(all);
  }

  function getAllowedServicesByDistrict(data, district){
  if(!district) return [];

  // ✅ Provincias (sentinel)
  if(district === "__provincia__") return ["provincia"];

  const z = data.zones || {};
  const in99  = (z.lima_99 || []).includes(district);
  const inHoy = (z.lima_hoy || []).includes(district);
  const in24  = (z.lima_24_48 || []).includes(district);
  const inProv= (z.provincia || []).includes(district);

  if(in99)  return ["lima_99","lima_hoy","lima_24_48"];
  if(inHoy) return ["lima_hoy","lima_24_48"];
  if(in24)  return ["lima_24_48"];
  if(inProv) return ["provincia"];

  return [];
}

  function saveState(state){
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch(e){}
  }
  function loadState(){
    try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch(e){ return {}; }
  }

  function qs(sel, root=document){ return root.querySelector(sel); }
  function qsa(sel, root=document){ return [...root.querySelectorAll(sel)]; }

  function openModal(modal){
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden","false");
  }
  function closeModal(modal){
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden","true");
  }

  function escapeHtml(s){
    return String(s).replace(/[&<>"']/g, m => ({
      "&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"
    }[m]));
  }

  function fillDistrictSelect(sel, data){
  const districts = getAllDistricts(data);

  sel.innerHTML =
    `<option value="">Selecciona…</option>` +
    `<option value="__provincia__">📦 Provincias (Shalom/Olva)</option>` +
    districts.map(d => `<option value="${escapeHtml(d)}">${escapeHtml(d)}</option>`).join("");
}

  function updateServiceOptions(serviceSel, allowed){
    const opts = qsa("option", serviceSel);
    opts.forEach(o=>{
      if(!o.value) return; // placeholder
      const ok = allowed.includes(o.value);
      o.disabled = !ok;
      o.hidden = !ok;
    });

    const current = serviceSel.value;
    if(current && !allowed.includes(current)){
      serviceSel.value = allowed[0] || "";
    } else if(!current && allowed[0]) {
      serviceSel.value = allowed[0];
    }
  }

  function setHint(modal, msg){
    const hint = qs("[data-ach-location-hint]", modal);
    if(hint) hint.textContent = msg || "";
  }

  function applyHeaderLabel(state){
    const el = document.querySelector("[data-ach-location-label]");
    if(!el) return;

    if(state && state.district){
      let serviceShort = "";
      if(state.service === "lima_99") serviceShort = "99 MIN";
      else if(state.service === "lima_hoy") serviceShort = "HOY";
      else if(state.service === "lima_24_48") serviceShort = "24-48h";
      else if(state.service === "provincia") serviceShort = "PROVINCIA";

      el.textContent = serviceShort ? `${state.district} • ${serviceShort}` : state.district;
    } else {
      el.textContent = "Ubicación";
    }
  }

  function init(){
    const data = window.ACH_LOCATION_DATA;
    if(!data) return;

    const modal = document.querySelector("[data-ach-location-modal]");
    if(!modal) return;

    const districtSel = qs("[data-ach-location-district]", modal);
    const serviceSel  = qs("[data-ach-location-service]", modal);
    const serviceWrap = qs("[data-ach-location-service-wrap]", modal);

    if(!districtSel || !serviceSel) return;

    fillDistrictSelect(districtSel, data);

    const state = loadState();
    if(state.district) districtSel.value = state.district;

    const allowed = getAllowedServicesByDistrict(data, districtSel.value);
    updateServiceOptions(serviceSel, allowed);

    if(state.service && allowed.includes(state.service)) {
      serviceSel.value = state.service;
    }

    const msgs = data.messages || {};
    setHint(modal, districtSel.value ? (msgs[serviceSel.value] || msgs.unknown) : (msgs.unknown || ""));
    applyHeaderLabel({ district: districtSel.value, service: serviceSel.value });

    districtSel.addEventListener("change", ()=>{
  const allowed2 = getAllowedServicesByDistrict(data, districtSel.value);

  // ✅ Si es Provincias: ocultar “Tipo de envío” y setear provincia
  if(serviceWrap){
    serviceWrap.style.display = (districtSel.value === "__provincia__") ? "none" : "";
  }

  updateServiceOptions(serviceSel, allowed2);

  if(districtSel.value === "__provincia__"){
    serviceSel.value = "provincia";
    setHint(modal, msgs.provincia || "Provincias: 2-5 días hábiles (Shalom/Olva).");
  } else {
    setHint(modal, districtSel.value ? (msgs[serviceSel.value] || msgs.unknown) : (msgs.unknown || ""));
  }
});

    serviceSel.addEventListener("change", ()=>{
  if(districtSel.value === "__provincia__"){
    setHint(modal, msgs.provincia || "");
    return;
  }
  setHint(modal, districtSel.value ? (msgs[serviceSel.value] || msgs.unknown) : (msgs.unknown || ""));
});

    document.addEventListener("click", (e)=>{
      const openBtn = e.target.closest("[data-ach-location-open]");
      if(openBtn){
        e.preventDefault();
        openModal(modal);
        return;
      }

      const closeBtn = e.target.closest("[data-ach-location-close]");
      if(closeBtn && modal.classList.contains("is-open")){
        e.preventDefault();
        closeModal(modal);
        return;
      }

      const saveBtn = e.target.closest("[data-ach-location-save]");
if(saveBtn){
  e.preventDefault();

  let st;

  if(districtSel.value === "__provincia__"){
    st = { district: "Provincias", service: "provincia", ts: Date.now() };
  } else {
    st = { district: districtSel.value, service: serviceSel.value, ts: Date.now() };
  }

  saveState(st);
  applyHeaderLabel(st);
  closeModal(modal);
  return;
}

      const clearBtn = e.target.closest("[data-ach-location-clear]");
      if(clearBtn){
        e.preventDefault();
        districtSel.value = "";
        updateServiceOptions(serviceSel, []);
        setHint(modal, msgs.unknown || "");
        saveState({});
        applyHeaderLabel({});
      }
    });
  }

  document.addEventListener("DOMContentLoaded", init);
})();

document.addEventListener("DOMContentLoaded", () => {
  const locBtn = document.querySelector('[data-ach-location-open]');
  if (!locBtn) return;

  const moveForMobile = () => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    if (!isMobile) return false;

    // Busca el botón hamburguesa / toggle del nav drawer
    const burger =
      document.querySelector('.js-drawer-open-nav') ||
      document.querySelector('[data-drawer-open]') ||
      document.querySelector('button[aria-controls="NavDrawer"]') ||
      document.querySelector('a[aria-controls="NavDrawer"]') ||
      document.querySelector('button[aria-label*="Menú"]') ||
      document.querySelector('button[aria-label*="Menu"]');

    if (!burger) return false;

    // Lo pone justo después del botón de menú (☰)
    burger.insertAdjacentElement("afterend", locBtn);
    locBtn.classList.add("ach-loc--mobile");
    return true;
  };

  const moveForDesktop = () => {
    // Limpia clase mobile si cambia de tamaño
    locBtn.classList.remove("ach-loc--mobile");

    const iconTargets = [
      ".header-icons",
      ".site-header__icons",
      ".site-header__actions",
      ".site-nav__icons",
      ".header__icons"
    ];

    let target = null;
    for (const sel of iconTargets) {
      const el = document.querySelector(sel);
      if (el) { target = el; break; }
    }

    if (!target) return;

    // Lo metemos antes del carrito (se ve como: cuenta + ubicación + carrito)
    target.insertBefore(locBtn, target.lastElementChild);
  };

  // Ejecuta 1 vez y también cuando se resizea
  const run = () => {
    if (moveForMobile()) return;
    moveForDesktop();
  };

  run();
  window.addEventListener("resize", run);
});


